import { TFunction } from "i18next";
import * as yup from "yup";

export const editEventNftSettingsSchema = (labelsT: TFunction, errorsT: TFunction) =>
  yup.object({
    occasionalNFTRule: yup.string().required(errorsT("required"))
  });
